/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'view': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<defs><path pid="0" d="M11 .5C6 .5 1.73 3.61 0 8c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5C20.27 3.61 16 .5 11 .5zM11 13c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8C9.34 5 8 6.34 8 8s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" id="svgicon_view_a"/></defs><g transform="translate(1 4)" _fill="none" fill-rule="evenodd"><mask id="svgicon_view_b" _fill="#fff"><use xlink:href="#svgicon_view_a"/></mask><use _fill="#000" fill-rule="nonzero" xlink:href="#svgicon_view_a"/><path pid="1" _fill="#242628" mask="url(#svgicon_view_b)" d="M-1-4h24v24H-1z"/></g>'
  }
})
